import React, { MouseEvent } from 'react'
import styled from 'styled-components'
import { Modal, Fonts, Button } from 'components/base-ui'
import { useTranslation } from 'react-i18next'
import { displayPrice } from 'helpers'
import { CurrentCartQuery } from 'graphQL/hatostore/generate/operations'
import { AdjustmentTypeEnumType } from 'enums'

interface ModalConfirmUseExceedVoucherProps {
  isOpen: boolean
  adjustments: CurrentCartQuery['currentCart']['adjustments']
  onRequestClose: VoidFunction
  onClickConfirm: (e: MouseEvent<HTMLButtonElement>) => void
  onClickGoBackToVoucherPage: VoidFunction
}

const ModalConfirmUseExceedVoucher = ({
  isOpen,
  adjustments,
  onRequestClose,
  onClickConfirm,
  onClickGoBackToVoucherPage,
}: ModalConfirmUseExceedVoucherProps) => {
  const { t } = useTranslation()

  let amountSatangs = 0
  let voucherAmount = 0
  adjustments.forEach((adjustment) => {
    if (adjustment.adjustmentType === AdjustmentTypeEnumType.Cash) {
      amountSatangs = amountSatangs + adjustment.amountSatangs
      voucherAmount = voucherAmount + adjustment.fullAmountSatangs
    }
  })

  return (
    <Modal hideCloseButton={false} isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalContent>
        <Title>{t('modal.modalConfirmUseExceedVoucher.title')}</Title>

        <Divider />
        <Row>
          <Text>{t('modal.modalConfirmUseExceedVoucher.fullAmountSatangs')}</Text>
          <Text>{displayPrice(-amountSatangs / 100)}</Text>
        </Row>
        <Row>
          <Text>{t('modal.modalConfirmUseExceedVoucher.voucher')}</Text>
          <Text>{displayPrice(voucherAmount / 100)}</Text>
        </Row>
        <Divider />
        <Row>
          <Text>{t('modal.modalConfirmUseExceedVoucher.exceedAmount')}</Text>
          <Text>
            <strong>฿{displayPrice((amountSatangs - voucherAmount) / 100)}</strong>
          </Text>
        </Row>
        <Divider />

        <WrapperButton>
          <Button float md2 onClick={onClickConfirm}>
            {t('modal.modalConfirmUseExceedVoucher.btnConfirmCheckout')}
          </Button>
          <Button float md2 onClick={onClickGoBackToVoucherPage} outline style={{ whiteSpace: 'nowrap' }}>
            {t('modal.modalConfirmUseExceedVoucher.btnBack')}
          </Button>
        </WrapperButton>
      </ModalContent>
    </Modal>
  )
}

export default ModalConfirmUseExceedVoucher

const ModalContent = styled.div`
  padding-top: 32px;
  padding-bottom: 16px;
  text-align: center;
`

const Title = styled(Fonts.H3)`
  margin-bottom: 15px;
`

const Text = styled(Fonts.BaseTitleRegular)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.base};
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${Text} {
    &:first-child {
      flex: 2;
      text-align: left;
    }
    &:last-child {
      flex: 1;
      text-align: right;
    }
  }
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  margin: 5px;
`

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-top: 25px;
`
